import script from "./submenu.vue?vue&type=script&lang=ts"
export * from "./submenu.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__